import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";

import { useCommunityBotProfileSearch } from "./useCommunityBotProfileSearch";

export const useShouldShowAgentsTab = ({ enabled = true } = {}) => {
  const { botProfiles } = useCommunityBotProfileSearch({
    name: "",
    disabled: !enabled,
  });

  const { memberChats } = useCommunityInboxStore();
  return botProfiles?.length > 0 || memberChats?.length > 0;
};
